const plusIcon = `<div class="plus-icon-wrapper"><svg class="plus-icon" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 12H18M12 6V18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg></div>`;

const minusIcon = `<div class="minus-icon-wrapper"><svg class="minus-icon" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 12H19" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg></div>`;

document
  .querySelectorAll(".product__accordion details")
  .forEach((accordion) => {
    const summary = accordion.querySelector("summary");
    const titleDiv = summary.querySelector(".summary__title");

    // Add plus icon initially to all closed accordions
    if (!accordion.hasAttribute("open")) {
      titleDiv.innerHTML += plusIcon;
    } else {
      titleDiv.innerHTML += minusIcon;
    }

    accordion.addEventListener("click", function (event) {
      // Prevent default behavior to properly handle the state
      event.preventDefault();

      document
        .querySelectorAll(".product__accordion details")
        .forEach((otherAccordion) => {
          if (otherAccordion !== accordion) {
            otherAccordion.removeAttribute("open");

            // Replace minus icon with plus icon for other accordions
            const otherSummary = otherAccordion.querySelector("summary");
            const existingMinusSvg = otherSummary.querySelector(".minus-icon");
            if (existingMinusSvg) {
              existingMinusSvg.remove();
              otherSummary.querySelector(".summary__title").innerHTML +=
                plusIcon;
            }
          }
        });

      // Toggle the current accordion
      const isOpen = !accordion.hasAttribute("open");
      const svgIcon = summary.querySelector(".plus-icon, .minus-icon");
      if (svgIcon) {
        svgIcon.remove();
      }

      if (isOpen) {
        accordion.setAttribute("open", "");
        summary.querySelector(".summary__title").innerHTML += minusIcon;
      } else {
        accordion.removeAttribute("open");
        summary.querySelector(".summary__title").innerHTML += plusIcon;
      }
    });
  });
